import React from 'react';
import styles from './MobileBanner.module.css';
import logo from '../../../images/ttg.png'
import supportCombined from '../../../images/2-in-1.png'
import MenuIcon from '@mui/icons-material/Menu';

const MobileBanner = ({ toggleCollapsed }) => {
    return (
        <div className={styles.banner}>
            <div className={styles.left}>
                <MenuIcon className={styles.menuIcon} onClick={toggleCollapsed} fontSize='large'></MenuIcon>
            </div>
            <div className={styles.middle}>
                <a href="/">
                    <div className={styles.logo}>
                        <img src={logo} alt="Logo" />
                    </div>
                </a>
            </div>
            <div className={styles.right}>
                <div className={styles.supportBlock}>
                    <img src={supportCombined} alt="Proudly Supports Energy Foundation Collective" className={styles.supportCombined} />
                </div>
                {/* <DemoSwitch onChangeDemoMode={onChangeDemoMode}></DemoSwitch> */}
            </div>
        </div>
    );
};

export default MobileBanner;
